











import AccountingSystem from "@/data/AccountingSystem";
import { Component, Vue, Prop } from "vue-property-decorator";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class SubSideNav extends Vue {
    @Prop({ type: Boolean })
    isBalance?: boolean;

    sideNavList: NavList[] = [
    ];

    activeIndex: number | null = 0;

    mounted() {
        if (this.isBalance) {
            if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.thirteenRule
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            } else if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.sevenNormal || this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.nineteenRule
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "共同", number: 6 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            }else if (
                this.$store.state.accountBook.accountingSystem ==
                AccountingSystem.rural
            ) {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "权益", number: 3 },
                    { name: "成本", number: 4 },
                    { name: "损益", number: 5 }
                ];
            }
            
             else {
                this.sideNavList = [
                    { name: "资产", number: 1 },
                    { name: "负债", number: 2 },
                    { name: "净资产", number: 7 },
                    { name: "收入", number: 8 },
                    { name: "费用", number: 9 }
                ];
            }
        }
    }

    letterClick(item: NavList, index: number) {
        this.activeIndex = index;
        this.$emit("update:nav", item.name);
        this.$emit("change", item);
    }
}
